/* eslint-disable */
// These values are overridden through clientBuild.
// The values are taken from 00_40_ template
export const dynamicValues = {
  buildVersion: '28a8586173e121217082670f31a313e5ac600d41',
};
/* eslint-enable */
